<template>
  <section v-on:click="sectionClicked" class="features iconSlider">
    <div class="cnt">
      <div class="swiperCnt loading" v-if="section.loading"></div>
      <div class="swiperCnt" v-else>
        <div class="sp spl" v-on:click="prevSlide"></div>
        <div class="sp spr" v-on:click="nextSlide"></div>
        <div class="swiperIn" v-if="section.items.length > 0">
          <swiper
            :slidesPerView="1"
            :loop="true"
            :breakpoints="{841:{slidesPerView: 3},641:{slidesPerView: 2}}"
            ref="swiper"
            :centeredSlides="true"
            :pagination="true"
            @swiper="onSwiper">
            <swiper-slide class="swiper-item"
              v-for="(item, i) in section.items" :key="`iconSlider${i}`">
              <div class="card">
                <div class="card-in">
                  <div class="card-icon" v-if="item.media[lang]"
                    :style="{'background-image': `url(${item.media[lang].imageSm})`}"
                    :class="{png: item.media[lang].mimetype === 'image/png'
                    || item.media[lang].mimetype === 'image/svg+xml'}"></div>
                  <div class="card-icon noImg" v-else></div>
                  <h4 class="card-title" v-if="item.title && item.title[lang]">
                    {{item.title[lang]}}</h4>
                  <h4 class="card-desc" v-if="item.descriptions && item.descriptions[lang]">
                    {{item.descriptions[lang]}}</h4>
                  <template v-if="item.url">
                    <router-link :to="item.url"
                      class="btn">{{item.buttonLabel[lang]}}</router-link>
                  </template>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div class="swiperIn" v-else>
          <swiper
            :slidesPerView="1"
            :loop="true"
            :breakpoints="{841:{slidesPerView: 3},641:{slidesPerView: 2}}"
            ref="swiper"
            :centeredSlides="true"
            :pagination="true"
            @swiper="onSwiper">
            <swiper-slide class="swiper-item"
              v-for="i in 3" :key="`iconSlider${i}`">
              <div class="card">
                <div class="card-in">
                  <div class="card-icon noImg"></div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Navigation, Pagination } from 'swiper';
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2';
import 'swiper/swiper-bundle.css';

SwiperCore.use([Navigation, Pagination]);

export default {
  name: 'home',
  props: ['section'],
  components: { Swiper, SwiperSlide },
  data() {
    return {
      newsIdx: 0,
      ch: null,
      loading: true,
      swiper: null,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
    onSwiper(swiper) {
      this.swiper = swiper;
    },
    prevSlide() {
      if (!this.swiper) return;
      this.swiper.slidePrev();
    },
    nextSlide() {
      if (!this.swiper) return;
      this.swiper.slideNext();
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.iconSlider{
  .swiperCnt{
    padding: 0;
    margin: 0;
    position: relative;
    &.loading{
      height: 360px;
      background-image: url(../../assets/loading.svg);
      background-position: center;
      background-repeat: no-repeat;
      background-size: 46px auto;
    }
    .sp{
      position: absolute;
      width: 40px; height: 40px;
      background-color: #fff;
      border-radius: 50%;
      top: 50%;
      transform: translateY(-50%);
      opacity: 1;
      background-size: 16px auto;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      transition: all .3s ease;
      z-index: 7;
      box-shadow: 0 0 4px rgba(0, 0, 0, .1);
      @media (max-width: 640px) {
        display: none;
      }
      &.spl{
        left: 6px;
        background-image: url(../../assets/arrow-left-black.png);
      }
      &.spr{
        right: 6px;
        background-image: url(../../assets/arrow-right-black.png);
      }
    }
    .swiper-item{
      transition: all .3s ease;
      &.swiper-slide-active{
        transform: scale(1.1);
      }
      .card{
        padding: 26px 20px 50px;
        box-sizing: border-box;
        .card-in{
          box-shadow: 0 0.5rem 1rem rgba(0,0,0,.15);
          color: #008552;
          padding: 3.125rem 1.875rem;
          position: relative;
          overflow: hidden;
          border: none;
          display: flex;
          flex-direction: column;
          min-width: 0;
          word-wrap: break-word;
          background-color: #fff;
          background-clip: border-box;
          box-sizing: border-box;
          border-radius: .3rem;
          text-align: center;
          width: 100%;
          // min-height: 180px;
          .card-icon{
            height: 64px; width: 64px;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            margin: 0 auto 10px;
            border-radius: 50%;
            &.png{
              border-radius: 0;
              background-size: contain;
            }
            &.noImg{
              background-color: #ccc;
              background-image: url(../../assets/image-black.png);
              background-size: 26px auto;
              opacity: .36;
            }
          }
          .card-title{
            font-size: 1.5rem;
            margin: .5rem 0 0;
            @media (max-width: 1140px) {
              font-size: 1.3rem;
            }
          }
          .card-desc{
            margin: 0;
            color: #767676;
            font-size: 15px;
            font-weight: 400;
          }
          .btn{
            color: #008552;
            width: max-content;
            height: max-content;
            padding: .5rem 1rem;
            margin-right: auto !important;
            margin-left: auto !important;
            margin-top: .5rem !important;
            border: 1px solid #008552;
            border-radius: .25rem;
            font-weight: normal;
            @media (max-width: 1480px) {
              padding: .4rem .8rem;
              font-size: 15px;
            }
            &:focus {
              box-shadow: 0 0 0 .25rem rgba(0,133,82,.5);
            }
            &:hover {
              background-color: #008552;
              color: #fff;
              box-shadow: none;
            }
          }
        }
      }
    }
  }
}
</style>
